import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { faExclamationTriangle, faCircleInfo, faCircleExclamation, faArrowUpRightFromSquare } from '@awesome.me/kit-2be97ecbd6/icons/classic/solid';
import clsx from 'clsx';

import styles from './BottomBar.module.css';

function BottomBar({ message, link, severity='warning' }) {
  const {t} = useTranslation();
  let icon = faCircleInfo
  switch (severity) {
    case 'alert':
      icon = faCircleExclamation;
      break;
    case 'warning':
      icon = faExclamationTriangle;
      break;
  }

  return (
    <div className={clsx(styles.BottomBar, styles[`BottomBar--${severity}`])}>
      <div className={styles.BottomBarMessage}>
        <FontAwesomeIcon icon={icon} className={styles.BottomBarIcon} />
        <div className={styles.BottomBarContent}>
          <span className={styles.BottomBarTitle}>{t(`bottomBar.${severity}`)}:</span>
          <span>{message}</span>
        </div>
      </div>
      {link && (
        <div className={styles.BottomBarActions}>
          <a href={link} target="_blank" className={clsx('btn', 'btn-outline-dark', styles.WarningBtn)}>
            <span>View Warning</span>
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
          </a>
        </div>
      )}
    </div>
  );
}

export default BottomBar;
